<script>
    import { selectedItem } from '../../../store/store.js';
    import { displayInt, displayBoolean } from '../../../utils/utils.js';
</script>

<div class="key-value-table box">
    <h5>Solenergi</h5>
    <table>
        <colgroup>
            <col style="width: 65%;">
            <col style="width: 30%;">
            <col style="width: 5%;">
        </colgroup>
        <tbody>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Solvärme</h6>
                </td>
                <td class="column2">
                <h6>{ displayBoolean($selectedItem?.solar_heat?.solar_heat_exist) }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            {#if $selectedItem?.solar_heat?.solar_heat_exist === true}
            <tr class="row100 body">
                <td class="column1">
                    <h6>Solfångsarea</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem?.solar_heat?.solar_capture_area) } m²</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Beräknad energiproduktion</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem?.solar_heat?.calculated_energy_production_per_year) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            {/if}
            <tr class="row100 body">
                <td class="column1">
                    <h6>Solceller</h6>
                </td>
                <td class="column2">
                <h6>{ displayBoolean($selectedItem?.solar_cell_system?.solar_cell_exist) }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            {#if $selectedItem?.solar_cell_system?.solar_cell_exist === true}
            <tr class="row100 body">
                <td class="column1">
                    <h6>Solcellsarea</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem?.solar_cell_system?.solar_cell_area) } m²</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Beräknad elproduktion</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem?.solar_cell_system?.calculated_electricity_production_per_year) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            {/if}
        </tbody>
    </table>
</div>